<template>
  <div class="lay-tabs" :class="{ 'lay-tabs-left': widthState }">
    <div class="nextLeft" @click="handleScrolls(240)">
      <Icon type="ios-arrow-back" size="25"/>
    </div>

    <div class="lay-tabs-list" @DOMMouseScroll="handlescroll" @mousewheel="handlescroll" ref="scrollOuter">
      <div class="lay-tabs-list-body" ref="scrollBody" :style="{left: tagBodyLeft + 'px'}">
        <Tag type="dot" @click.native.stop="$router.push({
                 path:'/home',
                 query:{
                   lib:$route.query.lib,
                   alis:$route.query.alis
                 }
               })"
             :color="activeRouter === '/home' || activeRouter === '/' ? 'primary' : 'default'">
          首页
        </Tag>
        <Tag type="dot" v-for="(w, j) in data" :key="j"
             closable
             @on-close="tagClose(w.value)"
             @click.native.stop="tagClick(w)"
             :color="activeRouter === '/' + w.value ? 'primary' : 'default'"
             @contextmenu.prevent.native="contextMenu(w.value, $event)">{{ w.label }}
        </Tag>
      </div>
    </div>

    <div class="nextRight" @click="handleScrolls(-240)">
      <Icon type="ios-arrow-forward" size="25"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menuState: Boolean
  },

  data() {
    return {
      tagBodyLeft: 0,
      data: []
    }
  },

  computed: {
    activeRouter() {
      return this.$route.path
    },

    widthState() {
      return this.menuState
    },

    lists() {
      return this.$store.getters.tabList
    }
  },

  methods: {

    /************************************************************
     *
     * 标签栏右键事件
     * @param   {e}                 当前标签栏
     *
     ************************************************************/
    contextMenu(a, b) {
    },

    /************************************************************
     *
     * 标签栏点击
     * @param   {e}                 当前标签栏
     *
     ************************************************************/
    tagClick(e) {
      this.$router.push({
                 path:`/${e.value}`,
                 query:{
                   lib:this.$route.query.lib,
                   alis:this.$route.query.alis
                 }
               })
    },

    /************************************************************
     *
     * 标签栏删除
     * @param   {e}                 当前标签栏
     *
     ************************************************************/
    tagClose(e) {
      let data = JSON.parse(this.$crypto.get(localStorage.getItem('tabList')))
      if (data.length) {
        let bool = data.findIndex(el => el.value === e)
        if (bool >= 0) {
          data.splice(bool, 1)
          this.handelLocalStorage(data, bool)
        }
      } else {
        this.$router.push({
                 path:'/home',
                 query:{
                   lib:this.$route.query.lib,
                   alis:this.$route.query.alis
                 }
               })
      }
    },

    /************************************************************
     *
     * 更新状态管理
     * @param   {data}              数据
     * @param   {index}             下标
     *
     ************************************************************/
    handelLocalStorage(data, index) {
      localStorage.setItem('tabList', this.$crypto.set(JSON.stringify(data)))
      this.updataStoreTabList()
      if (data.length) {
        let r = this.$route.path
        let a = index==0?`/${data[index].value}`:`/${data[index - 1].value}`
        this.$router.push({
                 path:a,
                 query:{
                   lib:this.$route.query.lib,
                   alis:this.$route.query.alis
                 }
               })
      } else {
        this.$router.push({
                 path:'/home',
                 query:{
                   lib:this.$route.query.lib,
                   alis:this.$route.query.alis
                 }
               })
      }
    },

    /************************************************************
     *
     * 更新状态管理
     *
     ************************************************************/
    updataStoreTabList() {
      this.$store.state.tabList = this.$crypto.get(localStorage.getItem('tabList'))
    },

    /************************************************************
     *
     * 标签栏滑动事件
     * @param   {e}                 标签栏滑动事件
     *
     ************************************************************/
    handlescroll(e) {
      var type = e.type
      let delta = 0
      if (type === 'DOMMouseScroll' || type === 'mousewheel') {
        delta = (e.wheelDelta) ? e.wheelDelta : -(e.detail || 0) * 40
      }
      this.handleScrolls(delta)
    },

    /************************************************************
     *
     * 标签栏滑动事件
     * @param   {offset}            滑动位置
     *
     ************************************************************/
    handleScrolls(offset) {
      const outerWidth = this.$refs.scrollOuter.offsetWidth
      const bodyWidth = this.$refs.scrollBody.offsetWidth
      if (offset > 0) {
        this.tagBodyLeft = Math.min(0, this.tagBodyLeft + offset)
      } else {
        if (outerWidth < bodyWidth) {
          if (this.tagBodyLeft < -(bodyWidth - outerWidth)) {
            this.tagBodyLeft = this.tagBodyLeft
          } else {
            this.tagBodyLeft = Math.max(this.tagBodyLeft + offset, outerWidth - bodyWidth)
          }
        } else {
          this.tagBodyLeft = 0
        }
      }
    }
  },

  mounted() {
    this.data = JSON.parse(this.lists)
  },

  watch: {
    lists: {
      handler(val, oldValue) {
        this.data = JSON.parse(val)
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.lay-tabs {
  height: 40px;
  position: absolute;
  left: 190px;
  right: 0;
  top: 0;
  background-color: aqua;
  transition: all .5s;

  &-left {
    left: calc(60px + 40px) !important;
  }

  &-list {
    overflow: hidden;
    display: flex;
    align-items: center;
    position: absolute;
    left: 30px;
    right: 30px;
    top: 0;
    bottom: 0;
    background-color: #F0F0F0;

    &-body {
      display: inline-block;
      padding: 1px 4px 0;
      position: absolute;
      overflow: visible;
      white-space: nowrap;
      -webkit-transition: left .3s ease;
      transition: left .3s ease;
    }
  }

  .nextLeft {
    width: 30px;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
  }

  .nextRight {
    width: 30px;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
  }
}
</style>

